import { CalenderIcon, InfoIcon } from "src/resources/icons";
import { Divider, Flex, HStack, Heading, Text, VStack, useMediaQuery } from "@chakra-ui/react";
import { ABOUT_ENG } from "src/common/constants/englishLabels";
import { Abot_Headings_Hin } from "src/common/constants/hindiLabels";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";


interface AboutProps {
  userData: any;
  /** When provided the component renders consultant contact info instead of bio/personal fields */
  consultantOverride?: {
    fullName: string;
    email: string;
    mobileNo: string;
    dailyRequestCountLimit: number;
    marriage_profile_limit: number;
  };
}

export const About: React.FC<AboutProps> = ({ userData, consultantOverride }) => {
  const [isSmallScreen] = useMediaQuery("(max-width: 630px)");

  const personal = userData?.personalDetails || {};
  const globalInfo = useSelector((state: RootState) => state.globalInfo);
  const { globalLanguage } = globalInfo;
  const isHindiLabels = globalLanguage === 'HI';

  const genderLabelMap: Record<string, { en: string; hi: string }> = {
    MALE: { en: "Male", hi: "पुरुष" },
    FEMALE: { en: "Female", hi: "महिला" },
  };

  const maritalStatusLabelMap: Record<string, { en: string; hi: string }> = {
    MARRIED: { en: "Married", hi: "विवाहित" },
    UNMARRIED: { en: "Unmarried", hi: "अविवाहित" },
  };

  // ── Consultant view ────────────────────────────────────────────────
  if (consultantOverride) {
    const c = consultantOverride;
    return (
      <Flex direction="column" width="100%" gap="1.5rem">
        <HStack>
          <InfoIcon />
          <Heading fontSize="34px">Contact Information</Heading>
        </HStack>

        <Flex
          direction={isSmallScreen ? "column" : "row"}
          gap="15rem"
          flexWrap="wrap"
        >
          <VStack alignItems="flex-start">
            <Heading fontSize="18px" color="#4A2C2A">Full Name</Heading>
            <Text>{c.fullName || "—"}</Text>
          </VStack>
          <VStack alignItems="flex-start">
            <Heading fontSize="18px" color="#4A2C2A">Email</Heading>
            <Text>{c.email}</Text>
          </VStack>
          <VStack alignItems="flex-start">
            <Heading fontSize="18px" color="#4A2C2A">Mobile No.</Heading>
            <Text>{c.mobileNo || "—"}</Text>
          </VStack>
        </Flex>

        <Divider mt="1rem" />

        <Heading fontSize="24px" color="#4A2C2A">Limits</Heading>
        <Flex
          direction={isSmallScreen ? "column" : "row"}
          gap="2rem"
          flexWrap="wrap"
        >
          <VStack alignItems="flex-start">
            <Heading fontSize="18px" color="#4A2C2A">Daily Request Limit</Heading>
            <Text>{c.dailyRequestCountLimit}</Text>
          </VStack>
          <VStack alignItems="flex-start">
            <Heading fontSize="18px" color="#4A2C2A">Profile Limit</Heading>
            <Text>{c.marriage_profile_limit}</Text>
          </VStack>
        </Flex>
      </Flex>
    );
  }

  // ── Regular user view ──────────────────────────────────────────────
  return (
    <Flex direction="column" width="100%" gap="1.5rem">
      {/* Section: Bio */}
      <HStack>
        <InfoIcon />
        <Heading fontSize="34px">{isHindiLabels ? Abot_Headings_Hin.BIO : ABOUT_ENG.BIO}</Heading>
      </HStack>
      <Text>
         {(userData as any)?.bio
          ? (userData as any).bio
           : isHindiLabels
           ? "कोई परिचय उपलब्ध नहीं है"
           : "No bio available"}
      </Text>

      <Divider mt="1rem" />

      {/* Section: Personal Info */}
      <Flex
        direction={isSmallScreen ? "column" : "row"}
        justifyContent="space-between"
        gap="2rem"
        flexWrap="wrap"
      >
        <VStack alignItems="flex-start">
          <HStack>
            <CalenderIcon />
            <Heading fontSize="30px">{isHindiLabels ? Abot_Headings_Hin.DOB : ABOUT_ENG.DOB}</Heading>
          </HStack>
          <Text>{personal.dob || "N/A"}</Text>
        </VStack>

        <VStack alignItems="flex-start">
          <Heading fontSize="30px">{isHindiLabels ? Abot_Headings_Hin.GENDER : ABOUT_ENG.GENDER}</Heading>
          <Text>{personal.gender
                 ? isHindiLabels
                 ? genderLabelMap[personal.gender]?.hi
                 : genderLabelMap[personal.gender]?.en
                 : "N/A"}
          </Text>
        </VStack>

        <VStack alignItems="flex-start">
          <Heading fontSize="30px">{isHindiLabels ? Abot_Headings_Hin.MARITIAL_STATUS : ABOUT_ENG.MARITAL_STATUS}</Heading>
          <Text>{personal.maritalStatus
                ? isHindiLabels
                ? maritalStatusLabelMap[personal.maritalStatus]?.hi
                : maritalStatusLabelMap[personal.maritalStatus]?.en
                : "N/A"}
          </Text>
        </VStack>
      </Flex>

      <Divider mt="1rem" />

      {/* Section: Aadhaar */}
      {/* <HStack>
        <AddharIcon />
        <Heading fontSize="24px">Aadhaar</Heading>
      </HStack>
      <Text>{personal.aadhaarCardNumber || "Not Provided"}</Text> */}
    </Flex>
  );
};
